import _objectSpread from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  "class": "group-system-header"
};
var _hoisted_2 = {
  "class": "applicationList"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  "class": "item"
};
var _hoisted_5 = {
  key: 0,
  "class": "item-nick"
};
var _hoisted_6 = {
  key: 1,
  "class": "item-nick"
};
var _hoisted_7 = {
  "class": "item-text"
};
var _hoisted_8 = {
  key: 0,
  "class": "item-btn"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  key: 1,
  "class": "item-btn"
};
var _hoisted_12 = {
  key: 0
};
var _hoisted_13 = {
  key: 1
};
import { ref, onMounted, onUnmounted } from "../../../../adapter-vue";
import { TUIStore, StoreName, TUITranslateService, TUIGroupService, TUIUserService } from "@tencentcloud/chat-uikit-engine";
import { isPC } from "../../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-group-system',
  props: {
    groupID: {
      type: String,
      "default": ""
    }
  },
  emits: ["toggleApplicationList", "handleGroupApplication"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var groupApplicationList = ref([]);
    var groupApplicationCount = ref(0);
    // - 申请类型：0 加群申请，2 邀请进群申请
    var getGroupApplicationList = function getGroupApplicationList() {
      TUIGroupService.getGroupApplicationList().then(function (res) {
        var applicationList = res.data.applicationList.filter(function (application) {
          return application.groupID === props.groupID;
        });
        var userIDList = [];
        applicationList.forEach(function (item) {
          item.applicationType === 0 ? item.applicant && userIDList.push(item.applicant) : item.userID && userIDList.push(item.userID);
        });
        userIDList = Array.from(new Set(userIDList));
        TUIUserService.getUserProfile({
          userIDList: userIDList
        }).then(function (res) {
          var profileList = res.data || [];
          profileList.forEach(function (profile) {
            applicationList.forEach(function (item) {
              if (item.applicationType === 0 && profile.userID === item.applicant) {
                item.avatar = profile.avatar || "";
              }
              if (item.applicationType === 2 && profile.userID === item.userID) {
                item.nick = profile.nick || "";
                item.avatar = profile.avatar || "";
              }
              item.actionStatus = "";
            });
          });
          groupApplicationList.value = applicationList;
        });
      });
    };
    var onGroupApplicationCount = function onGroupApplicationCount(count) {
      groupApplicationCount.value = count;
    };
    TUIStore.watch(StoreName.CUSTOM, {
      groupApplicationCount: onGroupApplicationCount
    });
    onMounted(function () {
      getGroupApplicationList();
    });
    onUnmounted(function () {
      TUIStore.unwatch(StoreName.CUSTOM, {
        groupApplicationCount: onGroupApplicationCount
      });
    });
    var toggleApplicationList = function toggleApplicationList() {
      emits("toggleApplicationList");
    };
    var handleApplication = function handleApplication(item, type) {
      TUIGroupService.handleGroupApplication({
        handleAction: type,
        application: _objectSpread({}, item)
      }).then(function () {
        item.actionStatus = type;
        // - 申请类型：0 加群申请，2 邀请进群申请
        var userID = item.applicationType === 0 ? item.applicant : item.userID;
        emits("handleGroupApplication", userID);
        groupApplicationCount.value -= 1;
        TUIStore.update(StoreName.CUSTOM, "groupApplicationCount", groupApplicationCount.value);
      });
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass([_unref(isPC) ? 'group-system-pc' : 'group-system'])
      }, [_createElementVNode("div", {
        "class": _normalizeClass([_unref(isPC) ? 'system-container-pc' : 'system-container'])
      }, [_createElementVNode("header", _hoisted_1, [_unref(isPC) ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        "class": "close",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return toggleApplicationList();
        })
      }, _cache[2] || (_cache[2] = [_createElementVNode("i", {
        "class": "icon icon-close"
      }, null, -1)]))) : (_openBlock(), _createElementBlock("span", {
        key: 1,
        "class": "close",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return toggleApplicationList();
        })
      }, _toDisplayString(_unref(TUITranslateService).t("\u5173\u95ED")), 1))]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupApplicationList), function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          "class": "application-item",
          key: index
        }, [_createElementVNode("img", {
          "class": "img-avatar",
          src: item.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
          onerror: "this.onerror=null;this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
        }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [item.applicationType === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(item.applicantNick || item.applicant), 1)) : _createCommentVNode("", true), item.applicationType === 2 ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(item.nick || item.userID), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(TUITranslateService).t("TUIChat.申请加入")), 1)]), item.actionStatus === '' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("p", {
          "class": "btn-agree",
          onClick: function onClick($event) {
            return handleApplication(item, 'Agree');
          }
        }, _toDisplayString(_unref(TUITranslateService).t("TUIChat.同意")), 9, _hoisted_9), _createElementVNode("p", {
          "class": "btn-reject",
          onClick: function onClick($event) {
            return handleApplication(item, 'Reject');
          }
        }, _toDisplayString(_unref(TUITranslateService).t("TUIChat.拒绝")), 9, _hoisted_10)])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [item.actionStatus === 'Agree' ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(TUITranslateService).t("TUIChat.已同意")), 1)) : _createCommentVNode("", true), item.actionStatus === 'Reject' ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(TUITranslateService).t("TUIChat.已拒绝")), 1)) : _createCommentVNode("", true)]))]);
      }), 128))])], 2)], 2);
    };
  }
});